import React from "react"

import background from "~/assets/images/bg-about.jpg"
import shape from "~/assets/images/two.svg"

// import { Button } from "~/components"
import { Logo } from "~/components/Header/styles"
import {
  Wrapper,
  Container,
  Figure,
  Content,
  ActionGroup,
  Branding,
} from "./styles"

export default function About() {
  return (
    <Wrapper>
      <Container>
        <Figure>
          <img src={background} alt="mudar isso depois" />
        </Figure>
        <Content>
          <h1>
            Se é feito para sua casa ou seu veículo, então é feito para você.
          </h1>
          <p>
            Um cano estourado, um chuveiro queimado, a bateria do carro que
            descarregou ou aquela pane elétrica...
          </p>
          <p>
            Todos passamos por imprevistos, mas quem conta com um plano de
            assistência emergencial pode ficar tranquilo. Foi pensando em você
            que escolhemos a Porto Seguro Faz como nossa parceira de
            atendimento, uma empresa que se preocupa em oferecer produtos e
            serviços que proporcionam mais segurança e conveniência. Assim, a
            gente cuida dos detalhes para você cuidar do que realmente importa.
          </p>
          <ActionGroup>
            <Logo type="portofaz" />
            {/* <Button size="small">Ver mais</Button> */}
          </ActionGroup>
        </Content>
      </Container>
      <Branding>
        <img src={shape} className="shape" />
        <Logo type="itau" />
      </Branding>
    </Wrapper>
  )
}
